import { render, staticRenderFns } from "./PageViewer.vue?vue&type=template&id=75b5c073&scoped=true&"
import script from "./PageViewer.vue?vue&type=script&lang=ts&"
export * from "./PageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PageViewer.vue?vue&type=style&index=0&id=75b5c073&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b5c073",
  null
  
)

export default component.exports